/**
 * @file tabs.component.tsx
 * @description Компонент табов для модального окна фильтрации в Task Manager приложении, который обеспечивает навигацию между различными группами фильтров через интерфейс вкладок. Интегрируется с react-hook-form для управления состоянием формы фильтров, динамически отображает содержимое вкладок на основе переданных tabObject элементов, поддерживает передачу control, setValue и getValues для синхронизации данных формы между вкладками.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-16
 * @dependencies ['react', '@consta/uikit/Tabs', '@src/types', 'react-hook-form']
 * @related-files ['src/features/filter/components/table-modal/table-modal.component.tsx', 'src/types/tab-object.ts']
 */

import { createElement, useState } from 'react';
import { Tabs as ConstaTabs } from '@consta/uikit/Tabs';
import { tabObject } from '@src/types';
import { IBaseObjectDTO } from '@src/types/dto';
import { FullForm } from '@src/types/form-props';
import { UseFormSetValue } from 'react-hook-form';

/**
 * Props для компонента табов формы фильтрации
 */
interface IFilterTabsProps extends FullForm {
    /** Массив объектов вкладок для отображения */
    items: tabObject[];
    /** Данные формы для передачи в компоненты вкладок */
    data?: IBaseObjectDTO;
    /** Функция установки значений формы из react-hook-form */
    setValue: UseFormSetValue<any>;
}

export const Tabs = ({ items, data, setValue, ...props }: IFilterTabsProps) => {
    const [tab, setTab] = useState<tabObject | null>(items[0]);

    return (
        <div className="tab_component flex flex-col flex-1 relative h-full">
            <ConstaTabs
                value={tab}
                items={items}
                getItemLabel={(item: tabObject) => item.label}
                className="mb-tabs"
                {...props}
                onChange={(newTab) => setTab(newTab as tabObject)}
            />

            {tab?.component && (
                <div className="tab_component-content h-full w-full">
                    {createElement(tab.component, {
                        ...props,
                        ...tab,
                        item: data,
                        setValue,
                    })}
                </div>
            )}
        </div>
    );
};
